import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { useSnapshot } from "valtio";

import { kioskStore } from "@pages/Kiosk/store";

import { ImageContent } from "./ImageContent";

import "./index.css";
import "swiper/swiper-bundle.min.css";

export function MainContentWrapper(): JSX.Element {
    const {
        project: {
            template: { content },
        },
    } = useSnapshot(kioskStore);

    const authenticationModesItems = (
        content.authenticationModes as ProjectContentItemType
    ).items;

    const activeAuthenticationModesItems = authenticationModesItems.filter(
        (item: ProjectMainContentItemType) => {
            return item.active === true;
        }
    );

    return (
        <React.Fragment>
            {activeAuthenticationModesItems.length <= 3 ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        padding: "50px 0px 50px 0px",
                        gap: "30px",
                        height: "294px",
                    }}
                >
                    {activeAuthenticationModesItems.map(
                        (item: ProjectMainContentItemType, index: number) => (
                            <ImageContent
                                item={item}
                                key={index}
                                activeAuthenticationModesItemsLength={
                                    activeAuthenticationModesItems.length
                                }
                            />
                        )
                    )}
                </div>
            ) : (
                <Swiper
                    className="swiper-pagination__clz"
                    slidesPerView={3}
                    slidesPerGroup={3}
                    spaceBetween={20}
                    modules={[Pagination]}
                    pagination={{
                        clickable: true,
                    }}
                >
                    {activeAuthenticationModesItems.map(
                        (item: ProjectMainContentItemType, index: number) => (
                            <SwiperSlide
                                key={item.id}
                                className="main-content-prm-swiper-slide__clz"
                            >
                                <ImageContent
                                    item={item}
                                    key={index}
                                    activeAuthenticationModesItemsLength={
                                        activeAuthenticationModesItems.length
                                    }
                                />
                            </SwiperSlide>
                        )
                    )}
                </Swiper>
            )}
        </React.Fragment>
    );
}
